import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import PrintDisabledIcon from '@mui/icons-material/PrintDisabled';
import { useNavigate } from 'react-router-dom';
import FlatwareIcon from '@mui/icons-material/Flatware';
import LocalDiningIcon from '@mui/icons-material/LocalDining';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import PeopleIcon from '@mui/icons-material/People';

const mainListItems = [
  { text: 'Home', icon: <HomeRoundedIcon />, path: '/Home' },
  // { text: 'Relatórios', icon: <AnalyticsRoundedIcon />, path: '/Relatorios' },
  // { text: 'Produtos', icon: <FastfoodIcon />, path: '/Produtos' },
  { text: 'Maquinas', icon: <PointOfSaleIcon />, path: '/Maquinas' },
  { text: 'Fotos dos produtos', icon: <CameraAltIcon />, path: '/FotosProdutos' },
  { text: 'Usuários', icon: <PeopleIcon />, path: '/Usuarios' },
  { text: 'Erros impressão', icon: <PrintDisabledIcon />, path: '/Impressao' },
  // { text: 'Grupos de produtos', icon: <FlatwareIcon />, path: '/Grupos' },
  // { text: 'Subgrupos de produtos', icon: <LocalDiningIcon />, path: '/SubGrupos' },
];

export default function MenuContent() {
  const navigate = useNavigate();

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {mainListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              selected={window.location.pathname === item.path}
              onClick={() => navigate(item.path)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}